import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

function Logo({ logo, intl }) {
  if (logo && logo.text) {
    return (
      <div className="Logo Logo--text">
        {intl.formatMessage({ id: logo.text })}
      </div>
    );
  }

  if (logo) {
    return <img className="Logo Logo--image" src={logo} alt="Company logo" />;
  }

  return <div className="Logo Logo--empty" />;
}

Logo.propTypes = {
  logo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  intl: PropTypes.object
};

export default injectIntl(Logo);



// WEBPACK FOOTER //
// ./src/modules/root/logo.js